import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * #759 D20 — «Nuevo» junto a un agente que sumó una plantilla, hasta que el usuario lo abre.
 */
const NewAgentTag = ({ sx }) => {
  const { t } = useTranslation();
  return (
    <Chip
      data-testid="new-agent-tag"
      label={t('agents.newTag', 'Nuevo')}
      size="small"
      color="primary"
      sx={{ height: 18, fontSize: '0.65rem', fontWeight: 600, flexShrink: 0, '& .MuiChip-label': { px: 0.75 }, ...sx }}
    />
  );
};

export default NewAgentTag;
